export default {"src":"/_next/static/media/theme-sun.e82caa5d.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};